import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import SolicitacaoService from "../../../services/SolicitacaoService";
import {getMensagemDeErro} from "../../../utils/functions";

export default class SolicitacaoRetroativaStore  {

    @observable solicitacaoEttId;
    @observable erro;
    @observable urlObtida;
    @observable tipo;

    constructor(modalStore, validacaoStore) {
        this.modalStore = modalStore;
        this.validacaoStore = validacaoStore;
        this.solicitacaoService = new SolicitacaoService();
    }

    setSolicitacaoEttId(numero) {
        this.solicitacaoEttId = numero;
    }

    setTipo(valor) {
        this.tipo = valor;
    }

    obterUrl() {
        this.modalStore.setSubmitted(true);
        this.modalStore.setSubmitMensagemErro("");
        if (this.validacaoStore.isValidForm) {
            this.solicitacaoService.obterUrlSolicitacaoRetroativa(this.solicitacaoEttId, this.tipo).then(response => {
                if(response.data) {
                    this.urlObtida = response.data
                }
            }).catch(error => {
                this.erro = getMensagemDeErro(error);
            });
        }
    }
}